import { restClient, jsonClient } from "../../lib/raftApi";

const state = {
  blsCodes: [],
  response: {
    Bodypart: {
      1: null,
      2: null,
      3: null,
      4: null,
    },
    Event: {
      1: null,
      2: null,
      3: null,
      4: null,
    },
    Nature: {
      1: null,
      2: null,
      3: null,
      4: null,
    },
    Source: {
      1: null,
      2: null,
      3: null,
      4: null,
    },
  },
  rootCauses: [],
};

const mutations = {
  setBlsCodes: (state, codes) => (state.blsCodes = codes),
  SET_RESPONSE: (state, payload) =>
    (state.response[payload.code_type][payload.level] = payload.id),
  setRootCauses: (state, causes) => (state.rootCauses = causes),
};
const getters = {
  getBlsCodes: (state) => state.blsCodes,
  availableLevels: (state, getters) => {
    const ret = {
      Bodypart: [],
      Event: [],
      Nature: [],
      Source: [],
    };
    for (const code_type of ["Bodypart", "Event", "Nature", "Source"]) {
      for (const level of ["1", "2", "3", "4"]) {
        if (!getters.disabledFor({ level, code_type })) {
          ret[code_type].push(level);
        }
      }
    }
    return ret;
  },
  availableOptions:
    (state, getters) =>
    ({ level, parentId, code_type }) => {
      let options = state.blsCodes.filter(
        (i) => i.code_type == code_type && i.level == level,
      );
      if (level > 1) {
        const code = getters.codeForId({ id: parentId, code_type });
        if (code != null) {
          options = options.filter((i) => i.parent == code);
        }
      }
      return options.sort((a, b) => a.order - b.order);
    },
  disabledFor:
    (state, getters) =>
    ({ level, code_type }) => {
      const parentNotSelected =
        getters.valueFor({ level: parseInt(level) - 1, code_type }) == "0";
      const hasParent = level !== "1";
      // console.log(`[disabledFor] ${code_type} ${level} parentNotSelected ${parentNotSelected} hasParent ${hasParent}`);
      if (hasParent && parentNotSelected) {
        return true;
      }
      return false;
    },
  formattedOptions:
    (state, getters) =>
    ({ level, parentId, code_type }) =>
      getters.availableOptions({ level, parentId, code_type }).map((i) => ({
        value: {
          id: i.id,
          code_type: i.code_type,
          code: i.code,
          level: i.level,
          title: i.title,
        },
        title: `${i.code} - ${i.title}`,
      })),
  valueFor:
    (state) =>
    ({ level, code_type }) => {
      if (level == "0") {
        return "0";
      }
      return state.response[[code_type]][[level]] || "0";
    },
  codeForId:
    (state) =>
    ({ id, code_type }) => {
      try {
        const match = state.blsCodes.find(
          (c) => c.code_type == code_type && c.id == id,
        );
        return match ? match.code : null;
      } catch (e) {
        return null;
      }
    },
};

const actions = {
  async fetchRootCauses({ commit, rootState }) {
    const queries = {
      "filter[vocab][condition][path]": "vid",
      "filter[vocab][condition][value]": "incident_investigation_root_causes",
    };
    const options = {
      path: "config_terms_term/config_terms_term",
      queries,
    };
    const response = await jsonClient.get(options).catch((error) => {
      console.error(error);
    });
    const causes = [];
    if (response.data.length !== 0) {
      response.data.forEach((rootCause) => {
        causes.push({
          id: rootCause.id,
          machine_name: rootCause.attributes.drupal_internal__id,
          label: rootCause.attributes.label,
        });
      });
    }
    commit("setRootCauses", causes);
  },
  async fetchBlsCodes({ state, commit, rootState }) {
    const options = {
      path: "/incident_management/bls_oiics_codes",
      queries: {},
    };
    const data = await restClient.get(options);
    let blsCodes = state.blsCodes;
    if (data.results.length !== 0) {
      blsCodes = data.results;
    }
    commit("setBlsCodes", blsCodes);
  },
  setResponse({ commit }, payload) {
    commit("SET_RESPONSE", payload);
  },
  setAlreadySelected({ state, commit }, payload) {
    const response = state.response;
    ["Bodypart", "Event", "Nature", "Source"].forEach((code_type) => {
      ["1", "2", "3", "4"].forEach((level) => {
        let container = null;
        if (payload[[code_type]]) {
          container = payload[[code_type]].find((i) => i.index == level);
        }
        const id = container ? container.value : null;
        if (id !== null) {
          commit("SET_RESPONSE", { code_type, level, id });
        }
      });
    });
  },
  clearAboveLevel({ commit }, payload) {
    const { level, code_type, code } = payload;
    if (level < 4) {
      for (let i = parseInt(level, 10) + 1; i <= 4; i++) {
        commit("SET_RESPONSE", {
          code: null,
          code_type: code_type,
          level: i,
        });
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
